import { createSlice } from '@reduxjs/toolkit';
import axios from 'src/utils/axios';
import type { AppThunk } from 'src/store';
import { FailureSnackbar } from './snackbar';
import { recordingStatus } from './presenter';
interface IAllowedPermissions {
    currentId?:string;
    name?: string;
    allowedPermissions?: Array<string>
}
interface IRoot {
    defaultVideoStatus: boolean,
    defaultAudioStatus: boolean,
    allowedPermissions?: IAllowedPermissions
    currentGroupId?: string
    vdiSharingName?: string
    screenSharingName?: string,
    eventLink: string,
    eventTitle: string,
    eventType: string,
    vdiPresent: boolean,
    isTriggerAccepted: boolean,
    studioId: string,
    divLayerEnable: boolean,
    currentScreenSharedTrack: any | null,
    videoSharingParticipants: any | null,
    nonVideoSharingParticipants: any | null,
}

const initialState: IRoot = {
    defaultVideoStatus: false,
    defaultAudioStatus: false,
    allowedPermissions: {
        currentId:'',
        name: "",
        allowedPermissions: []
    },
    currentGroupId: "",
    vdiSharingName: "",
    screenSharingName: "",
    eventLink: "",
    eventTitle: "",
    eventType: "",
    vdiPresent: false,
    isTriggerAccepted: false,
    studioId:"",
    divLayerEnable: false,
    currentScreenSharedTrack: null,
    videoSharingParticipants: [],
    nonVideoSharingParticipants: [],
};
const slice = createSlice({
    name: 'meeting',
    initialState,
    reducers: {
        setVidioStatus(state, action) {
            state.defaultVideoStatus = action.payload;
        },
        setAudioStatus(state, action) {
            state.defaultAudioStatus = action.payload;
        },
        setAllowedPermission(state, action) {
            if (action.payload) {
                state.allowedPermissions = action.payload;
                state.allowedPermissions.currentId = action.payload.id;
            }
        },
        setGroupID(state, action) {
            state.currentGroupId = action.payload;
        },
        setVdiSharingName(state, action) {
            state.vdiSharingName = action.payload;
        },
        setScreenSharingName(state, action) {
            state.screenSharingName = action.payload;
        },
        setEventLink(state, action) {
            state.eventLink = action.payload;
        },
        setEventTitle(state, action) {
            state.eventTitle = action.payload;
        },
        setEventType(state, action) {
            state.eventType = action.payload;
        },
        setVdiPresent(state, action) {
            state.vdiPresent = action.payload;
        },
        setIsTriggerAccepted(state, action) {
            state.isTriggerAccepted = action.payload;
        },
         setStudioId(state, action) {
            state.studioId = action.payload;
        },
        onResizing(state, action) {
            state.divLayerEnable = action.payload;
        },
        setCurrentScreenSharedTrack(state, action) {
            state.currentScreenSharedTrack = action.payload;
        },
        setVideoSharingParticipant(state, action) {
            state.videoSharingParticipants = action.payload;
        },
        setNonVideoSharingParticipant(state, action) {
            state.nonVideoSharingParticipants = action.payload;
        }
    }
});
const APP_BASE_URL = process.env.REACT_APP_API_URL;

export const audioAction = (value: boolean): AppThunk => async (dispatch) => {
    dispatch(slice.actions.setAudioStatus(value));
};

export const videoAction = (value: boolean): AppThunk => async (dispatch) => {
    dispatch(slice.actions.setVidioStatus(value));
};

export const sharedScreenAction = (data: any): AppThunk => async (dispatch) => {
    dispatch(slice.actions.setCurrentScreenSharedTrack(data));
};

export const setAllowPermission = (data: any): AppThunk => async (dispatch) => {
    dispatch(slice.actions.setAllowedPermission(data));
};

export const storeCurrentGroupID = (data: any): AppThunk => async (dispatch) => {
    dispatch(slice.actions.setGroupID(data));
};

export const storeVdiSharingName = (data: any): AppThunk => async (dispatch) => {
    dispatch(slice.actions.setVdiSharingName(data));
};

export const storeScreenSharingName = (data: any): AppThunk => async (dispatch) => {
    dispatch(slice.actions.setScreenSharingName(data));
};

export const storeEventLink = (data: any): AppThunk => async (dispatch) => {
    dispatch(slice.actions.setEventLink(data));
};

export const storeEventTitle = (data: any): AppThunk => async (dispatch) => {
    dispatch(slice.actions.setEventTitle(data));
};
export const storeEventType = (data: any): AppThunk => async (dispatch) => {
    dispatch(slice.actions.setEventType(data));
};
export const storeVdiPresent = (data: any): AppThunk => async (dispatch) => {
    dispatch(slice.actions.setVdiPresent(data));
};
export const storeIsTriggerAccepted = (data: any): AppThunk => async (dispatch) => {
    dispatch(slice.actions.setIsTriggerAccepted(data));
};
export const storeStudioId = (data: any): AppThunk => async (dispatch) => {
    dispatch(slice.actions.setStudioId(data));
};
export const onResizingHandler = (data: boolean): AppThunk => async (dispatch) => {
    dispatch(slice.actions.onResizing(data));
};

export const setVideoSharingParticipants = (data: any) => async (dispatch) => {
    dispatch(slice.actions.setVideoSharingParticipant(data));
};

export const setNonVideoSharingParticipants = (data: any) => async (dispatch) => {
    dispatch(slice.actions.setNonVideoSharingParticipant(data));
};

export const stopRecordingAPIHit = (data: boolean, Name: string): AppThunk => async (dispatch) => {
    try {
        const payload = {
            trigger: data ? "start" : "stop",
            name: Name
        };
      const response = await axios.post(`${APP_BASE_URL}/events/api/v1/recording/${payload.trigger}`);
      if (!response?.data?.status) {
        dispatch(
          FailureSnackbar({
            message: response?.data?.message || "Failed to start recording",
            open: true,
          })
        );
        dispatch(recordingStatus(false));
      }
        
    } catch (error) {
        throw new Error(error);
    }
};

export const downloadRecording =
  (data, lastChunk): AppThunk =>
  async () => {
    const MAX_RETRIES = 3; // Set the maximum number of retries for upload call

    for (let retryCount = 0; retryCount < MAX_RETRIES; retryCount++) {
      try {
        const formData = new FormData();
        formData.append("context_id", window.location.href.split("/")[4]);
        formData.append("file", data);
        formData.append("last_chunk", lastChunk);
        await axios.patch(`${APP_BASE_URL}/service-orchestrator/api/v1/record/upload`, formData);
        break;
      } catch (error) {
        if (retryCount === MAX_RETRIES - 1) {
          throw new Error(`Maximum retries reached: ${error}`);
        }
        await new Promise((resolve) => setTimeout(resolve, 1000));
      }
    }
  };

export const playbookTrigger = (callback: () => void): AppThunk => async () => {
  try {
   const response =  await axios.post(`${APP_BASE_URL}/events/api/v1/playbook/trigger`);
   if (response?.data) {
       callback();
   }
  } catch (error) {
    throw new Error(error);
  }
};

export const reducer = slice.reducer;
export default slice;
